export default {
  methods: {
    confirmDelete(id, title, text, deleteRequest, deletedHandler) {
      this.$modal.show("dialog", {
        title: title,
        text: text,
        buttons: [
          {
            title: "Тийм",
            handler: () => {
              this.$modal.hide("dialog");
              this.$store.dispatch("setLoading", true);
              const data = JSON.parse("{}");
              data.id = id;
              data.status = 2;
              deleteRequest({}, data)
                .then(response => {
                  if (response.data.payload.toast !== null)
                    this.showToast(response.data.payload.toast);

                  deletedHandler(id);
                  this.$store.dispatch("setLoading", false);
                })
            }
          },
          {
            title: "Болих"
          }
        ]
      });
    }
  }
};
